<div class="w-full">
  <ng-container *ngIf="paginationUnidadeOrganica?.data?.length; else simpleCoursesView">
    <!-- Accordion para Unidades Orgânicas -->
    <p-accordion
      [style]="{ width: '100%' }"
      [(activeIndex)]="activeIndex"
      (activeIndexChange)="onActiveIndexChange($event)">

      <p-accordionTab
        *ngFor="let unidade of paginationUnidadeOrganica?.data; let i = index; trackBy: trackById"
        [header]="unidade.nome"
        style="text-transform: uppercase;">

        <app-search-bar
          [showFilterBtn]="true"
          (onFilterBtnClick)="showFilterModal()"
          primaryBtnLabel="Associar Curso"
          (onPrimaryBtnClick)="showDialog(unidade.id)"
          (formValueChange)="handleFormValueChange($event)">
        </app-search-bar>

        <ng-container *ngIf="pagination.data?.length; else noDataUnidade">
          <app-table
            [pagination]="pagination"
            [columns]="columns"
            [actions]="actionOptions"
            (pageChange)="onPageChange($event)"
            (actionSelected)="onActionSelected($event)">
          </app-table>
        </ng-container>

        <ng-template #noDataUnidade>
          <div class="no-data">
            <app-data-void
              titulo="Nenhum curso encontrado!"
              descricao="Sem cursos associados a esta unidade orgânica.">
            </app-data-void>
          </div>
        </ng-template>

      </p-accordionTab>
    </p-accordion>

    <div class="pagination-controls">
      <app-paginator-control
        [first]="((paginationUnidadeOrganica.pageNumber ?? 1) - 1) * (paginationUnidadeOrganica.pageSize ?? 10)"
        [rows]="paginationUnidadeOrganica.pageSize ?? 10"
        [totalRecords]="paginationUnidadeOrganica.totalRecords ?? 0"
        (pageChange)="onPageChangeUnidadeOrganica($event)">
      </app-paginator-control>
    </div>
  </ng-container>

  <!-- View Simples: sem unidades orgânicas -->
  <ng-template #simpleCoursesView>
    <app-search-bar
      [showFilterBtn]="true"
      (onFilterBtnClick)="showFilterModal()"
      primaryBtnLabel="Associar Curso"
      (onPrimaryBtnClick)="showDialog(instituicaoEnsinoID)"
      (formValueChange)="handleFormValueChange($event)">
    </app-search-bar>

    <ng-container *ngIf="pagination.data?.length; else noData">
      <app-table
        [pagination]="pagination"
        [columns]="columns"
        [actions]="actionOptions"
        (pageChange)="onPageChange($event)"
        (actionSelected)="onActionSelected($event)">
      </app-table>
    </ng-container>

    <ng-template #noData>
      <div class="no-data">
        <app-data-void
          titulo="Nenhum curso encontrado!"
          descricao="Clique em Associar Curso para associar um.">
        </app-data-void>
      </div>
    </ng-template>
  </ng-template>
</div>

<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>

<!-- Drawer: Detalhes do curso -->
<p-drawer
  [(visible)]="ShowCursoDetails"
  header="Detalhes do curso"
  position="right"
  [style]="{ width: '720px' }"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-container *ngIf="ShowCursoDetails">
    <app-instituicoes-ensino-detalhe-curso
      (onClose)="cancel()"
      [curso]="cursoSelecionado">
    </app-instituicoes-ensino-detalhe-curso>
  </ng-container>
</p-drawer>

<!-- Dialog: Filtros -->
<p-dialog
  header="Filtros"
  [modal]="true"
  [(visible)]="showFilter"
  [style]="{ width: '40rem' }"
  appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Dropdown -->
      <p-select
        *ngIf="filter.type === 'dropdown'"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        [options]="filter.options"
        [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel"
        [optionValue]="filter.optionValue">
      </p-select>

      <!-- Texto -->
      <input
        *ngIf="filter.type === 'text'"
        pInputText
        [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder"
        class="w-full" />
    </div>
  </form>

  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>